import { NoticiaSchema } from "../domain/entities/Noticia";
import { fileManagementService } from "../services/fileManagementService";
import { newsService } from "../api/newsService";
import { fileFromValue } from "../utils/fileUtils";

export const updateNews = async (id, formData, originalData = {}) => {
  const parsed = NoticiaSchema.parse({
    ...formData,
    fijado:
      formData.fijado === true ||
      formData.fijado === "true" ||
      formData.fijado === "1",
  });

  // Si no se sube un archivo nuevo se conserva la URL (o el archivo) previo.
  let imgUrl = parsed.img || originalData.img;
  let previewUrl = parsed.preview || originalData.preview;
  // id_img es el identificador del archivo en el storage; se actualiza con el
  // fileName que devuelve la API de subida cuando se reemplaza el archivo.
  let idImg = originalData.id_img || parsed.id_img;

  // El UploadField entrega un File único (maxFiles=1); fileFromValue
  // también acepta FileList/array por compatibilidad con <input type="file">.
  const imgFile = fileFromValue(formData.img);
  const previewFile = fileFromValue(formData.image_preview);

  if (imgFile || previewFile) {
    const result = await fileManagementService.uploadNewsFiles({
      img: imgFile,
      preview: previewFile,
    });
    imgUrl = result.imgUrl || imgUrl;
    previewUrl = result.previewUrl || previewUrl;
    if (result.imgName) {
      idImg = result.imgName;
    }
  }

  const payload = {
    id: id || parsed.id,
    titulo: parsed.titulo,
    bajada: parsed.bajada,
    fijado: Boolean(parsed.fijado),
    fecha_publicacion: parsed.fecha_publicacion,
    descripcion: parsed.descripcion,
    etiqueta: parsed.etiqueta,
    tipo: parsed.tipo,
    url: parsed.url,
    img: imgUrl,
    id_img: idImg,
    preview: previewUrl,
  };

  const response = await newsService.updateNews(payload.id, payload);
  return response;
};

export default updateNews;